module.exports = __webpack_public_path__ + "static/media/step5-a.3dcc6fd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step5-a.png
// module id = 3739
// module chunks = 0